import { render, staticRenderFns } from "./Magazzino.vue?vue&type=template&id=39944364&scoped=true&"
import script from "./Magazzino.vue?vue&type=script&lang=js&"
export * from "./Magazzino.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39944364",
  null
  
)

export default component.exports